import styled from "styled-components";
import AuthLayoutHeaderBackground from "@/assets/svg/AuthLayoutHeaderBackground";

export const OTPButtons = styled.div.attrs({
  className: "OTPButtons",
})`
  margin-top: 2.4rem;

  display: flex;
  justify-content: space-between;
`;

export const OTPInputSeparator = styled.div.attrs({
  className: "OTPInputSeparator",
})`
  height: 1px;
  width: 1.8rem;

  place-self: center;
  background-color: var(--whale-light);
`;

export const Box = styled.div.attrs({
  className: "authLayoutBox",
})`
  width: 100%;
  text-wrap: wrap;
  border: 1px solid var(--smoke-dark, #d3dce6);
  border-radius: 0.8rem;
`;

export const Header = styled.div.attrs({
  className: "authLayoutHeader",
})<{ $percentage?: number }>`
  position: relative;
  z-index: 0;

  width: 100%;
  height: fit-content;

  padding: 2.4rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 1.2rem;

  border-bottom: ${(props) =>
    props.$percentage !== undefined
      ? "none"
      : "1px solid var(--turquoise-dark, #19AEC3)"};
  background-color: var(--snow, #f9fafc);
  overflow: hidden;
  transition: height 150ms;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;

  @media (max-width: 640px) {
    padding: 1.2rem;
  }

  ${(props) =>
    props.$percentage !== undefined
      ? `
      &::after {
        content: "";

        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;

        width: ${props.$percentage}%;
        height: 0.2rem;

        background-color: var(--turquoise-dark, #19AEC3);
        transition: width 100ms;
      }
    `
      : ""}
`;

export const HeaderBackground = styled(AuthLayoutHeaderBackground).attrs({
  className: "authLayoutHeaderBackground",
})`
  position: absolute;
  z-index: -1;
  top: 0;
  bottom: 0;
  right: 0;

  pointer-events: none;
`;

export const Title = styled.h1.attrs({
  className: "authLayoutTitle",
})`
  margin: 0;

  color: var(--black, #212121);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold) !important;
  line-height: 150%;
`;

export const SubText = styled.p.attrs({
  className: "subText",
})`
  color: var(--black, #212121);
  font-size: var(--font-size-s);
  font-weight: var(--font-weight-regular);
  line-height: 150%;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.8rem;

  margin: 0;
`;

export const Body = styled.div.attrs({
  className: "authLayoutBody",
})`
  width: 100%;
  padding: 2.4rem;
  --otp-input-width: 7.2rem;
  --space-between-inputs: 1fr;

  @media (max-width: 640px) {
    --otp-input-width: minmax(3.2rem, 1fr);
    --space-between-inputs: 0.8rem;
    padding: 1.2rem;

    > div:first-child {
      overflow: auto;
    }

    .TextFormElementContainer {
      aspect-ratio: 1 / 1;

      .TextFormElement {
        aspect-ratio: 1 / 1;

        > .TextFormElementContent {
          height: 100% !important;
          padding: 0.2rem 0.8rem !important;
        }
      }
    }
  }
`;
